import { SxProps, Theme } from '@mui/material';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import type { AttachmentKind } from 'src/pages/Conversations/SidePanel/ConversationDetails/Attachments/attachment-utils';

const KIND_ICON_NAME: Record<AttachmentKind, string> = {
  image: 'image',
  pdf: 'file-text',
  document: 'file-text',
  other: 'file',
};

const kindIconSx = (kind: AttachmentKind): SxProps<Theme> => ({
  flexShrink: 0,
  color: (theme) => {
    const { sys } = theme.palette.custom.OV;
    if (kind === 'pdf') return sys.error;
    if (kind === 'image') return sys.tertiary;
    return sys.onSurfaceVariant;
  },
});

interface AttachmentKindIconProps {
  kind: AttachmentKind;
  size: number;
}

export const AttachmentKindIcon = ({ kind, size }: AttachmentKindIconProps) => (
  <DynamicIcon
    name={KIND_ICON_NAME[kind]}
    library="lucide"
    size={size}
    data-icon-name={KIND_ICON_NAME[kind]}
    sx={kindIconSx(kind)}
  />
);
